import { PaymentMethod } from '../../models';
import { ServiceCardRepresentationNumberRepresentation } from './ServiceCardNumberRepresentation';
import { CustomFormattedMessage } from '../../i18n/i18n';

type ServiceCardListRepresentationProps = {
  serviceCards: PaymentMethod[];
  maxNumberOfCardsToShow: number;
};

export const ServiceCardListRepresentation = ({
  serviceCards,
  maxNumberOfCardsToShow,
}: ServiceCardListRepresentationProps) => {
  let cards: PaymentMethod[];
  const hasTooManyCards = serviceCards.length > maxNumberOfCardsToShow;
  if (hasTooManyCards) {
    cards = serviceCards.slice(0, maxNumberOfCardsToShow);
  } else {
    cards = serviceCards;
  }
  return (
    <div className={'display-flex flex-row gap-15'}>
      {cards.length === 0 && '—'}
      {cards.map((paymentMethod) => {
        return (
          <div key={paymentMethod.id}>
            <ServiceCardRepresentationNumberRepresentation
              paymentPartner={paymentMethod.paymentPartner}
              lastFourDigits={paymentMethod.lastFourDigits}
            />
          </div>
        );
      })}
      {hasTooManyCards && (
        <span className={'text-decoration-underline'}>
          <CustomFormattedMessage
            id={
              serviceCards.length - cards.length === 1
                ? 'onboarding.vehicleTable.table.extraCards.singular'
                : 'onboarding.vehicleTable.table.extraCards.plural'
            }
            values={{
              numberOfCards: serviceCards.length - cards.length,
            }}
          />
        </span>
      )}
    </div>
  );
};
